<template>
    <div>

        <!-- /////////////////////////////////////////////////////
            //             PANTALLA PRINCIPAL     //
            /////////////////////////////////////////////////////    -->

        <v-row class="mx-1">
            <v-col cols="12" sm="3" md="" class="py-0">
                <v-autocomplete label="Estudiante" :items="AlumnosFam" autocomplete="off"
                v-model="datosAlumno" item-value="id_alumno" item-text="persona.nombre_completo" @change="cargarDocentes(datosAlumno)"
                return-object></v-autocomplete>
            </v-col>


            <v-col cols="12" sm="3" md="" class="py-0">
                <div class="nivel">
                    <p>Nivel:</p><span>{{ datosAlumno.desc_nivel }}</span>
                </div>
            </v-col>


            <v-col cols="12" sm="3" md="" class="py-0">
                <div class="grado">
                    <p>Grado:</p><span>{{ datosAlumno.desc_grado }}</span>
                </div>
            </v-col>

            <v-col cols="12" sm="3" md="" class="py-0">
                <div class="seccion">
                    <p>Sección:</p><span> {{ datosAlumno.nombre_seccion }}</span>
                </div>
            </v-col>
        </v-row>





        <v-col cols="12" sm="12" md="12" class="pb-0 px-0">
            <v-alert dense border="left"  class="text-center" color="#0277bd" dark>
                <h5>LISTADO DE DOCENTES</h5>
            </v-alert>
        </v-col>



    <!-- Listado de Docentes en formato de tarjetas -->
    <v-row>
            <v-col cols="4" v-for="item in datos" :key="item.id" class="mb-4">
                <v-card class="" max-width="400">
                    <v-row class="pl-1">
                        <!-- Avatar / Imagen del Docente -->
                        <v-col cols="4">
                            <v-avatar v-if="configColegio.rest_padre_familia_avatar" color="grey" size="65" class="ml-3">
                                <v-icon v-if="!item.avatar_persona" color="grey-darken-3">fa-solid fa-user</v-icon>
                                <img v-else 
                                    :src="`${rutaServer+item.ruta_avatar_persona+item.avatar_persona}`"
                                    class="fondo_add_img"
                                    dark
                                    size="100" />
                            </v-avatar>

                            <v-avatar color="grey" size="65" v-if="configColegio.rest_padre_familia_avatar==false" class="ml-3">
                                <v-icon color="grey-darken-3">fa-solid fa-user</v-icon>
                            </v-avatar>
                        </v-col>
                        <!-- Información del Docente -->
                        <v-col cols="8">
                            <h5 class="font-weight-regular text-grey">Apellidos y nombres:</h5>
                            <h4 class="font-weight-bold">{{item.nombre_pers}} </h4>

                            <h5 class="font-weight-regular text-grey">Curso:</h5>
                            <h4 class="font-weight-bold">{{item.desc_curso}}</h4>

                            <h5 class="font-weight-regular text-grey" v-if="configColegio.rest_padre_familia_correo">Correo:</h5>
                            <h4 class="font-weight-bold" v-if="configColegio.rest_padre_familia_correo">{{item.correo_persona}}</h4>

                            <h5 class="font-weight-regular text-grey" v-if="configColegio.rest_padre_familia_telf">Teléfono:</h5>
                            <h4 class="font-weight-bold" v-if="configColegio.rest_padre_familia_telf">{{item.telf_persona}}</h4>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <!-- fin de pantalla principal -->

        <br>
        <br>
        <span v-if="test">
            <v-row>

            <code>Alumno: {{JSON.stringify(alumno)}}</code> <br>
            <code>Datos: {{JSON.stringify(datos)}}</code>
            <code>ConfigColegio: {{JSON.stringify(configColegio)}}</code>

         <code>AlumnosFam: {{JSON.stringify(datosAlumno)}}</code>
          <code>id_persona: {{id_persona}}</code>
            </v-row>

        </span>




    </div>
</template>





<script>
    import axios, {API_URL} from "@/helpers/axios";
    import { mapMutations, mapGetters, mapActions } from "vuex";


    export default {
        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente: { id_submodulo: 147, id_modulo: 7 }, //sud_modulo y modulo

            datoLogin: sessionStorage, // variables de sesion del usuario
            test:false,
            rutaServer: API_URL,
            ////////////////////////////////////////////////////////
            datosAlumno: {},
            id_persona:{},
            AlumnosFam: [],

            datos: [],
            alumno: [],
            configColegio:{}
        }),



        computed: {
            ...mapGetters("login", ["componenteEvento"]),
        },

        mounted() {
            this.loadMain();
        },


        created() {
            this.actualizarParamentro();
        },


        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //----- Validar accesos por perfil ------------
            ...mapActions("login", ["parametroComponente"]),

            actualizarParamentro() {
            this.parametroComponente(this.paramComponente);
            },

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations("mensajeSis", ["setEnviarMens"]),
            ////////////////////////////////////////////////////////


            /*********Cargar Hijos de Familiar ******** */
            async loadMain() {
                //this.$Files.dowload()
                try {
                    let params = {
                        id_colegio: sessionStorage.id_colegio,
                        id_persona: sessionStorage.id_persona,
                        id_anio_lectivo: sessionStorage.id_ano_lectivo,
                    };
                    const response = await axios.post("/academico/padre/all/alu/", params);
                    this.AlumnosFam = response.data;
                    //console.log('los hijos'+JSON.stringify(this.AlumnosFam))
                }

                catch (error) {
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }
            },



            //  ------- MOSTRAR TODOS LOS REGISTROS    --------
            async cargarDocentes(alumno) {

                console.log('cargarDocentes')

                Object.keys(alumno).forEach(key =>{
                    if(key == 'persona.id')
                        this.id_persona = alumno[key]
                        console.log(key, ':', alumno[key])

                } );


                let id_colegio = sessionStorage.id_colegio
                let id_periodo = sessionStorage.id_ano_lectivo
                let id_persona = this.id_persona
                try {
                    let response = await axios.get(`/academico/docente/listDocente/colegio/${id_colegio}/ano_lectivo/${id_periodo}/persona/${id_persona}`);
                    let datos = response.data

                    this.alumno = datos.alumno
                    this.datos = datos.docentesSeccion
                    this.configColegio = datos.configColegio

                }
                catch (error) {
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }

            },

        },
    };
</script>





<style  scoped>
.nivel,
.grado,
.seccion {
  width: 100%;
  height: 50px;
  position: relative;
  border-bottom: 1px solid #1565c0;
}

.nivel span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.seccion span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.grado span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}
.nivel p {
  font-size: 13px;
}
.grado p {
  font-size: 13px;
}
.seccion p {
  font-size: 13px;
}
@media (max-width: 425px) {
  .seccion {
    margin-bottom: 10px;
  }
}
#contenedor {
  margin-bottom: 100px;
}
.card-alumnos {
  width: 100%;
  height: auto;
  background: #fff;
  border: 1px solid #b7babb;
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0px 2px 9px 3px #b7babb;
  padding-bottom: 5px;
}
.title-alumnos {
  width: 100%;
  height: 20px;
  background: #0c67b8;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.alumno {
  width: 100%;
  padding-top: 9px;
  padding-left: 8px;
}

</style>
